export function getWeekStart(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - d.getDay());
  return d;
}

export function formatDateISO(date: Date): string {
  return date.toISOString().split('T')[0]; // YYYY-MM-DD
}

export function generateFilename(data: any[]): string {
  if (!data || data.length === 0) return 'diabetes-log';
  
  // Use the latest date in the dataset
  const latestDate = new Date(data[data.length - 1].finalTime);
  const weekStart = getWeekStart(latestDate);
  
  return `diabetes-log-week-of-${formatDateISO(weekStart)}`;
} 